/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CustomOption from './CustomOption/index'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogClearAction from 'DesignSystem/TysiaListDialog/TysiaListDialogClearAction/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSaveAction from 'DesignSystem/TysiaListDialog/TysiaListDialogSaveAction/index'
import TysiaListDialogSearchCapture from 'DesignSystem/TysiaListDialog/TysiaListDialogSearchCapture/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/Filters/ProvidersAndAssistants/Content/Content",
  closePopover
  
}) {
let providersAndAssistantsValueData = fromData.useDataValue({ viewPath,
context: 'providers_and_assistants',
})
let tabSelectedSidebarEmployeeResourcesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.sidebar_employee_resources',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  closePopover
  
})
let onFilter = fromHelpers.useOnFilter({
  children,
  viewPath,
  closePopover
  
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 data="providers_and_assistants"
 items={providersAndAssistantsValueData}
 data="tab.selected.sidebar_employee_resources"
 selected={tabSelectedSidebarEmployeeResourcesValueData}
 onSubmit={onSubmit}
 closePopover={closePopover}
 onFilter={onFilter}
 width={286}
 height={336}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-3-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title="Select providers & assistants"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaListDialogClearAction
  viewPath={`${viewPath}/TysiaListDialogClearAction`}
/>
<TysiaListDialogSaveAction
  viewPath={`${viewPath}/TysiaListDialogSaveAction`}
 text="Apply"
/>
</div>
</div>
<TysiaListDialogSearchCapture
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogSearchCapture`}
/>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
>
{childProps => (
<CustomOption
{...childProps}
/>
)}
</TysiaListDialogItems>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}